import { BlockBlobClient, newPipeline } from '@azure/storage-blob';
import { IWorkBenchLayout } from '@fox/blocks';
import {
	filterOutConditionals,
	IQuestionAnswer,
	ISection,
	SwiftFoxSearchResult,
	UploadedFilesWithMeta
} from '@fox/forms-runtime';
import { GetFormSasInputModel } from '../../Membership/goals/contracts';
import { CalculateFormPointsInputModel } from '../contracts';
import { addContentId, mutateHelper, queryHelper } from './fetch-templates';
export async function fetchPointsTotal(input: {
	requestToken: string;
	contentId: string;
	sections: ISection[];
	layout: IWorkBenchLayout | undefined;
	answers: IQuestionAnswer[];
	formId: number;
}): Promise<{ status: 'success' | 'error'; pointTotal?: number; message?: string }> {
	const { answers, layout, sections, contentId, requestToken, formId } = input;
	const filteredAnswers = filterOutConditionals(layout, answers, sections);
	const finalAnswers = filteredAnswers.map(({ questionName, answer }) => {
		return {
			questionName,
			...answer
		};
	});

	let url = '/Umbraco/Api/Membership/CalculateFormPoints';

	const res = await mutateHelper<number, CalculateFormPointsInputModel>({ contentId, formId, answers: finalAnswers }, requestToken, url);

	return { status: 'success', pointTotal: res.data };
}
export async function complete(input: {
	contentId: string;
	requestToken: string;
	searchString: string;
	types?: string[];
	categories?: string[];
	signedParams?: string;
}): Promise<SwiftFoxSearchResult[] | undefined> {
	const { searchString, types, categories, contentId, requestToken } = input;
	let url = `/Umbraco/Api/Membership/SwiftFoxEntities?${addContentId(contentId)}`;
	if (types?.length) {
		url += types.map(type => `&types=${encodeURIComponent(type)}`).join('');
	}
	if (categories?.length) {
		url += categories.map(type => `&categories=${encodeURIComponent(type)}`).join('');
	}
	if (searchString?.length) {
		url += `&searchString=${encodeURIComponent(searchString)}`;
	}

	const res = await queryHelper<SwiftFoxSearchResult[]>(requestToken, url);
	if (res.error) {
		throw new Error(res.error);
	}
	return res.data;
}
const pipeline = newPipeline();
export async function uploadFile(input: {
	requestToken: string;
	contentId: string;
	file: File;
	formId: number;
}): Promise<UploadedFilesWithMeta | undefined> {
	const { file, formId, requestToken, contentId } = input;
	const url = '/Umbraco/Api/Membership/GetFormAttachmentSas';
	const res = await mutateHelper<string, GetFormSasInputModel>({ contentId, fileName: file.name, surveyId: formId }, requestToken, url);

	if (!res?.data || res.error) {
		alert('Unable to upload the file at this time');
		return;
	}
	const blobClient = new BlockBlobClient(res.data, pipeline);
	await blobClient.uploadData(await file.arrayBuffer(), {
		onProgress(progress) {
			console.log('Uploading... ', file.size, progress.loadedBytes);
		}
	});

	return {
		fileName: file.name,
		mime: file.type,
		url: blobClient.url.split('?')[0],
		size: file.size
	};
}
